var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import equal from 'fast-deep-equal';
import React from 'react';
import { SelectMode } from '../api';
import { ApplicationContext } from '../context';
import { Container } from '../services/di';
import { compileUrl } from '../services/actions';
import { ItemList } from '../item-list';
import { of, Subject } from 'rxjs';
import { Typography, Checkbox, Box, Icon, Button, MenuItem, Chip } from '@material-ui/core';
import Row from '../Row';
import ComponentMenu from '../ComponentMenu';
import { renderDynamicComponent } from '../render';
import CircularProgress from '@material-ui/core/CircularProgress';
import { takeUntil } from 'rxjs/operators';
import ComplexFilter from '../ComplexFilter';
;
export var SortType;
(function (SortType) {
    SortType["Asc"] = "asc";
    SortType["Desc"] = "desc";
})(SortType || (SortType = {}));
var Grid = /** @class */ (function (_super) {
    __extends(Grid, _super);
    function Grid(props, ctx) {
        var _this = _super.call(this, props, ctx) || this;
        _this._until = new Subject();
        _this.itemList = new ItemList(function (offset, payload) {
            if (_this.props.control.path) {
                if (_this.props.dataState) {
                    var items = _this.props.dataState.get(_this.props.control.path) || [];
                    return of(items);
                }
                else {
                    return of([]);
                }
            }
            else {
                var compiledUrl = compileUrl(_this.props.control.endpoint, _this.props.dataState);
                return Container.http.get(compiledUrl, _this.props.dataState.compileQuery(__assign(__assign(__assign({}, payload), (_this.props.control.filter.data || {})), { $offset: offset, $count: 20, $distinct: true, $select: _this._getGridSelectColumns(), $sort: (Object.values(_this.state.sortState)
                        .map(function (sort) { return ({
                        path: sort.column.path,
                        sortType: sort.sortType
                    }); }) || []) })));
            }
        });
        _this.state = {
            loading: true,
            selection: {},
            activeRowId: null,
            selectionCount: null,
            totalCount: null,
            currentFilter: null,
            selectedInstances: [],
            items: [],
            sortState: {}
        };
        return _this;
    }
    Grid.prototype.componentDidMount = function () {
        var _this = this;
        console.log(this.props.control);
        this.itemList.items
            .subscribe(function (items) { return _this.setState({
            items: items
        }); });
        this.itemList.loading
            .subscribe(function (loading) { return _this.setState({
            loading: loading
        }); });
        if (this.props.dataState) {
            this.props.dataState.recordChange
                .pipe(takeUntil(this._until))
                .subscribe(function () { return _this.refreshData(); });
        }
        this.refreshData();
    };
    Grid.prototype.componentWillUnmount = function () {
        this._until.next();
        this._until.complete();
    };
    Grid.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.control.endpoint != nextProps.control.endpoint) {
            this.refreshData();
        }
        if (equal(this.props.selectedIds, nextProps.selectedIds) == false) {
            var selection_1 = {};
            nextProps.selectedIds.map(function (id) { return selection_1[id] = true; });
            this.setState({
                selection: selection_1,
                selectionCount: nextProps.selectedIds.length
            });
            this._refreshSelectedInstances(selection_1);
        }
    };
    Grid.prototype.refreshData = function (filter, silent) {
        if (silent === void 0) { silent = false; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.props.control.endpoint) {
                    this.itemList.refresh(filter);
                    this.refreshTotalCount();
                }
                else if (this.props.control.path) {
                    this.setState({
                        items: this.props.dataState.get(this.props.control.path)
                    });
                }
                return [2 /*return*/];
            });
        });
    };
    Grid.prototype.onRowClick = function (item) {
        this.setState({
            activeRowId: item.id
        });
        if (this.props.onRowClick) {
            this.props.onRowClick(item);
        }
        if (this.props.onActiveRow) {
            this.props.onActiveRow(item);
        }
    };
    Grid.prototype.changeSelection = function (id) {
        this.setState({
            activeRowId: null
        });
        if (this.props.onActiveRow) {
            this.props.onActiveRow(null);
        }
        if (this.props.control.selectMode == SelectMode.Single && this.state.selection[id] != true) {
            this.cancelSelection();
        }
        this.state.selection[id] = !this.state.selection[id];
        var selectedRecordIds = this._refreshSelectedInstances();
        if (this.props.onSelectionChange) {
            this.props.onSelectionChange(selectedRecordIds);
        }
    };
    Grid.prototype._refreshSelectedInstances = function (selection) {
        if (selection === void 0) { selection = this.state.selection; }
        var selectedRecordIds = Object.keys(selection)
            .filter(function (id) { return selection[id]; })
            .map(function (id) { return id; });
        this.setState({
            selectionCount: selectedRecordIds.length
        });
        this.forceUpdate();
        return selectedRecordIds;
    };
    Grid.prototype.refreshTotalCount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var total;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.props.control.endpoint.indexOf('?') == -1)) return [3 /*break*/, 2];
                        return [4 /*yield*/, Container.http.get(this.props.control.endpoint + '/count', __assign(__assign({}, this.state.currentFilter), { $distinct: true }))];
                    case 1:
                        total = _a.sent();
                        this.setState({
                            totalCount: total
                        });
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    Grid.prototype.cancelSelection = function () {
        this.setState({
            selection: {},
            selectedInstances: [],
            selectionCount: 0
        });
        if (this.props.onSelectionChange) {
            this.props.onSelectionChange([]);
        }
    };
    Grid.prototype.cancelActiveRow = function () {
        this.setState({
            activeRowId: null
        });
        if (this.props.onActiveRow) {
            this.props.onActiveRow(null);
        }
    };
    Grid.prototype.selectAllLoaded = function () {
        var _this = this;
        this.itemList.getAllItems()
            .forEach(function (item) {
            _this.state.selection[item.id] = true;
        });
        this.setState({
            selection: this.state.selection,
            selectionCount: (this.state.selection ? Object.keys(this.state.selection).length : 0)
        });
        var selectedRecordIds = this._refreshSelectedInstances();
        if (this.props.onSelectionChange) {
            this.props.onSelectionChange(selectedRecordIds);
        }
    };
    Grid.prototype.selectAllFiltered = function () {
        return __awaiter(this, void 0, void 0, function () {
            var records, selection, ids;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Container.http.get(this.props.control.endpoint, __assign(__assign({}, this.state.currentFilter), { $offset: 0, $count: -1, $distinct: true, $select: ['id'] }))];
                    case 1:
                        records = _a.sent();
                        selection = {};
                        ids = records
                            .map(function (record) { return record.id; });
                        ids
                            .forEach(function (id) { return selection[id] = true; });
                        if (this.props.onSelectionChange) {
                            this.props.onSelectionChange(ids);
                        }
                        this.setState({
                            selection: selection,
                            selectionCount: ids.length
                        });
                        if (this.props.onSelectionChange) {
                            this.props.onSelectionChange(ids);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Grid.prototype.onFilterChange = function (filter) {
        // this.preventRefreshingFilter = true;
        this.refreshData(filter);
    };
    Grid.prototype.render = function () {
        var _this = this;
        var _a;
        return React.createElement(React.Fragment, null,
            React.createElement(Box, { p: 2 },
                React.createElement(Row, { gap: 1 },
                    React.createElement(Typography, { variant: "h6" }, this.props.control.label),
                    React.createElement(ComponentMenu, { component: React.createElement(Button, { variant: "outlined", color: "primary", startIcon: React.createElement(Icon, null, "list"), endIcon: React.createElement(Icon, null, "arrow_drop_down") }, "V\u00FDb\u011Br") },
                        this.state.selectionCount > 0 && React.createElement(MenuItem, { onClick: function () { return _this.cancelSelection(); } }, "Zru\u0161it v\u00FDb\u011Br"),
                        React.createElement(MenuItem, { onClick: function () { return _this.selectAllLoaded(); } },
                            "Ozna\u010Dit viditeln\u00E9 ",
                            React.createElement(Chip, { variant: "outlined", size: "small", label: this.state.items.length })),
                        React.createElement(MenuItem, { onClick: function () { return _this.selectAllFiltered(); } },
                            "Ozna\u010Dit v\u0161e filtrovan\u00E9 ",
                            React.createElement(Chip, { variant: "outlined", size: "small", label: this.state.totalCount }))),
                    React.createElement(ComplexFilter, { items: this.props.control.filter.extended, onFilterChanged: function (filterData) { return _this.onFilterChange(filterData); } },
                        React.createElement(Button, { variant: "outlined", color: "primary", startIcon: React.createElement(Icon, null, "filter_list"), endIcon: React.createElement(Icon, null, "arrow_drop_down") }, "Filtr")),
                    this.props.control.buttons.map(function (button, index) { return renderDynamicComponent(index, button, _this.props.dataState); }))),
            React.createElement(Table, { size: "small", style: { width: '100%' } },
                React.createElement(TableHead, null,
                    React.createElement(TableRow, null,
                        React.createElement(TableCell, { padding: "checkbox" }),
                        this.props.control.columns.map(function (column, index) {
                            return React.createElement(TableCell, { key: index, style: { width: column.width + "px" } }, column.label);
                        }))),
                this.state.loading && React.createElement("caption", { style: { textAlign: 'center' } },
                    React.createElement(CircularProgress, null)),
                this.state.items.length > 0 && this.state.loading == false && React.createElement(TableBody, null, this.state.items.map(function (item, index) {
                    return React.createElement(TableRow, { selected: _this.state.activeRowId == item.id || _this.state.selection[item.id], hover: true, key: index, onClick: function () { return _this.onRowClick(item); } },
                        React.createElement(TableCell, { padding: "checkbox" },
                            React.createElement(Checkbox, { checked: _this.state.selection[item.id] || false, onChange: function () { return _this.changeSelection(item.id); }, onClick: function (event) { return event.stopPropagation(); } })),
                        _this.props.control.columns
                            .map(function (column, index) {
                            return React.createElement(TableCell, { key: index, style: { width: column.width + "px" } }, item[column.path]);
                        }));
                })),
                this.state.loading == false && ((_a = this.state.items) === null || _a === void 0 ? void 0 : _a.length) == 0 && React.createElement("caption", null, "\u017D\u00E1dn\u00E9 polo\u017Eky")));
    };
    Grid.prototype._getGridSelectColumns = function () {
        var select = ['id'];
        this.props.control.columns
            .forEach(function (column) {
            if (column.valuePattern) {
                // select = select.concat(this.dynamic.getPatternPaths(column.valuePattern).map(deepPath => `${column.path}.${deepPath}`));
            }
            else {
                select.push(column.path);
            }
        });
        return select;
    };
    Grid.contextType = ApplicationContext;
    return Grid;
}(React.Component));
export default Grid;
//# sourceMappingURL=Grid.js.map